import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/common/ModalComponent'
import { showAlert } from 'services/alerts.service'

const DeviceGroupModal = ({ isOpen, handleSave, handleClose, selectedDevice }) => {
  const { t } = useTranslation()
  const handleSaveClick = formData => {
    if (!formData.groupName || formData.groupName.trim() === '') {
      showAlert({
        text: t('mgmt.deviceGroupModal.nameRequired'),
        icon: 'warning'
      })
      return
    }

    const dataToSave = selectedDevice?.deviceId
      ? { ...formData, deviceId: selectedDevice.deviceId }
      : { ...formData, deviceId: undefined }

    handleSave(dataToSave)
    handleClose()
  }

  return (
    <ModalComponent
      title={selectedDevice?.deviceId ? t('mgmt.deviceGroupModal.editTitle') : t('mgmt.deviceGroupModal.createTitle')}
      isOpen={isOpen}
      onClose={handleClose}
      onSave={handleSaveClick}
      initialData={selectedDevice ? { groupName: selectedDevice.groupName || '' } : { groupName: '' }}
    >
      {({ formData, handleChange }) => (
        <label className='block text-sm font-medium'>
          {t('mgmt.deviceGroupModal.groupName')} *
          <input
            type='text'
            name='groupName'
            value={formData.groupName || ''}
            onChange={handleChange}
            className='w-full mt-1 p-2 border rounded'
          />
        </label>
      )}
    </ModalComponent>
  )
}

export default DeviceGroupModal
